// MachineUtilizationDashboard/components/MachineKpiCards.jsx

import {
  formatNumber,
  formatPercentage,
} from "../utils/machineDashboardUtils";

const KPI_ITEMS = [
  {
    key: "totalMachines",
    label: "Total Machines",
    icon: "bi-cpu",
    tone: "primary",
    getSubText: (data) =>
      `${formatNumber(data?.machinesWithRuntime)} with runtime`,
  },
  {
    key: "runningMachines",
    label: "Running Now",
    icon: "bi-play-circle-fill",
    tone: "success",
    getSubText: (data) =>
      `${formatPercentage(data?.runningPercentage)} of total`,
  },
  {
    key: "idleMachines",
    label: "Idle Machines",
    icon: "bi-pause-circle-fill",
    tone: "warning",
    getSubText: (data) =>
      `${formatPercentage(data?.idlePercentage)} of total`,
  },
  {
    key: "stoppedMachines",
    label: "Stopped",
    icon: "bi-stop-circle-fill",
    tone: "danger",
    getSubText: (data) =>
      `${formatPercentage(data?.stoppedPercentage)} of total`,
  },
  {
    key: "machinesWithProduction",
    label: "With Production",
    icon: "bi-box-seam-fill",
    tone: "purple",
    getSubText: () => "Machines producing output",
  },
];

function MachineKpiCards({ data = {} }) {
  return (
    <div className="mud-kpi-grid">
      {KPI_ITEMS.map((item) => (
        <article
          className={`mud-kpi-card mud-kpi-card--${item.tone}`}
          key={item.key}
        >
          <div className="mud-kpi-card__glow" />

          <div className="mud-kpi-card__top ">
            <div className="mud-kpi-card__icon">
              <i className={`bi ${item.icon}`} />
            </div>
            <span className="mud-kpi-card__label">{item.label}</span>
            <span className="mud-kpi-card__pulse" />
          </div>

          <div className="mud-kpi-card__content">
            

            <strong className="mud-kpi-card__value">
              {formatNumber(data?.[item.key])}
            </strong>

            <small>{item.getSubText(data)}</small>
          </div>
        </article>
      ))}
    </div>
  );
}

export default MachineKpiCards;